var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTwitter = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 36,
  height: 36,
  viewBox: "0 0 36 36"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#00B6F1",
  d: "M18 0C8.1 0 0 8.1 0 18s8.1 18 18 18 18-8.1 18-18S27.9 0 18 0m9.1 14.4v.6c0 6-4.6 12.9-12.9 12.9-2.6 0-5-.8-7-2.1.4.1.7.1 1.1.1 2.1 0 4.1-.7 5.6-2-1.9 0-3.6-1.3-4.2-3.1.3.1.6.1.9.1.4 0 .8-.1 1.1-.2-2-.4-3.6-2.2-3.6-4.4v-.1q.9.6 2.1.6C8.9 16 8.1 14.6 8.1 13c0-.8.3-1.6.7-2.3 2.2 2.8 5.5 4.6 9.3 4.8-.1-.4-.1-.7-.1-1.1 0-2.5 2-4.5 4.5-4.5 1.3 0 2.5.5 3.3 1.4 1.1-.2 2-.6 2.9-1.1-.3 1.1-1 2-2 2.5.9-.1 1.8-.3 2.6-.7-.6.9-1.3 1.7-2.2 2.4"
})));
export default SvgTwitter;